import React from "react";
import { Box, Link, Typography, Divider } from "@mui/material";
import CustomCard from "../../components/cards/CustomCard";
import RegisterStepper from "./RegisterStepper";

export const Register = () => {
  return (
    <CustomCard variant="outlined" width="60%" topMargin={1}>
      <RegisterStepper />

      {/* Reset & Login */}
      <Box sx={{ mt: 3, textAlign: "center" }}>
        <Typography sx={{ mt: 1 }}>
          Already have an account?{" "}
          <Link href="/login" variant="body2">
            Login
          </Link>
        </Typography>
      </Box>
    </CustomCard>
  );
};
